import Navibar from "./Navibar";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <div className="w-full ">
      {/* Banner - Uncomment if needed
      <div className="w-full bg-gray-700 text-white py-2 px-4 text-center sticky top-0 z-50">
        <p className="text-[14px] font-medium">
          Helix AI is live — your autonomous blockchain AI agent.{" "}
          <a 
            href="https://ai.helix.org"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:opacity-80 transition-opacity font-semibold"
          >
            Try it now
          </a>
        </p>
      </div>
      */}
      <Navibar />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
